.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: calc(
    var(--outlet-layout-width) - var(--outlet-layout-padding-tab-template)
  );
  position: sticky;
  left: 24px;

  &.scroll-y {
    @media screen and (width >= 1400px) {
      max-width: calc(
        var(--outlet-layout-width) - var(
            --offset-width-filter-tab-component,
            48px
          )
      );
    }
  }

  &.kai-open {
    --offset-width-filter-tab-component: calc(var(--width-ai-chat) + 91px);
  }

  &.tab-position-left {
    width: initial;
    max-width: initial;
  }
}

.show-placeholder {
  left: 0;
}
